<div class="device-container p-1">
  <!-- When device count is zero, PGH Only and PGH+M -->
  <ng-container *ngIf="totalDevices === 0">
    <!-- When device count is zero, PGH+M -->
    <ng-container *ngIf="isMobilePlan">
      <ng-container *ngIf="!isMobileSize">
        <div class="d-flex">
          <div class="icon-container">
            <mat-icon *ngIf="isMobileDevice" [svgIcon]="'mobile-phones'"></mat-icon>
            <mat-icon *ngIf="!isMobileDevice" [svgIcon]="'wi-fi-connected-devices'"></mat-icon>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column padding-10">
              <p class="u-heading-5" *ngIf="isMobileDevice">
                <adp-label *ngIf="isMobileDevice" labelKey="Dashboard_Mobile_Heading"></adp-label>
                <adp-label *ngIf="!isMobileDevice" labelKey="Dashboard_Devices_SubHeading"></adp-label>
              </p>
              <p class="u-body-2" *ngIf="isMobileDevice">
                <adp-label *ngIf="isMobileDevice" labelKey="Dashboard_Mobile_Component_Text"></adp-label>
                <adp-label *ngIf="!isMobileDevice" labelKey="Dashboard_Devices_SubHeading2"></adp-label>
              </p>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
              <a
                routerLink="{{ deviceRoute }}"
                [disabled]="isDisabledController"
                sf-aria-label="Global_GetStarted_Aria_Label"
                gtmClick="Manage Devices"
                gtmLinkURL="CTA">
                <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isMobileSize">
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="d-flex">
                <div class="icon-container">
                  <mat-icon *ngIf="isMobileDevice" [svgIcon]="'mobile-phones'"></mat-icon>
                  <mat-icon *ngIf="!isMobileDevice" [svgIcon]="'wi-fi-connected-devices'"></mat-icon>
                </div>
                <p class="u-heading-5 align-content" *ngIf="isMobileDevice">
                  <adp-label *ngIf="isMobileDevice" labelKey="Dashboard_Mobile_Heading"></adp-label>
                  <adp-label *ngIf="!isMobileDevice" labelKey="Dashboard_Devices_SubHeading"></adp-label>
                </p>
              </div>
              <div>
                <p class="u-body-2" *ngIf="isMobileDevice">
                  <adp-label *ngIf="isMobileDevice" labelKey="Dashboard_Mobile_Component_Text"></adp-label>
                  <adp-label *ngIf="!isMobileDevice" labelKey="Dashboard_Devices_SubHeading2"></adp-label>
                </p>
              </div>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
              <a
                routerLink="{{ deviceRoute }}"
                [disabled]="isDisabledController"
                sf-aria-label="Global_GetStarted_Aria_Label"
                gtmClick="Manage Devices"
                gtmLinkURL="CTA">
                <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- When device count is zero, PGH Only -->
    <ng-container *ngIf="!isMobilePlan">
      <div class="d-flex pt-2 pb-2 pl-2 pr-0">
        <div class="d-flex">
          <div class="d-flex flex-column align-items-center">
            <img class="device-img mb-3" [src]="smartDeviceImage?.ImageURL" [alt]="smartDeviceImage?.Caption" />
            <p class="u-heading-5 mt-2 text-center"><adp-label labelKey="Dashboard_Devices_SubHeading"></adp-label></p>
            <p class="u-body-2 text-center padding-left-right-device">
              <adp-label labelKey="Dashboard_Devices_Component_Label"></adp-label>
            </p>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
            <a
              routerLink="{{ deviceRoute }}"
              [disabled]="isDisabledController"
              sf-aria-label="Global_GetStarted_Aria_Label"
              gtmClick="Manage Devices"
              gtmLinkURL="CTA">
              <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="totalDevices > 0">
    <ng-container *ngIf="isMobilePlan">
      <div class="d-flex pt-2 pb-2 pl-2 pr-0">
        <div class="p-3 mr-2" *ngIf="!isMobileSize">
          <mat-icon *ngIf="isMobileDevice" [svgIcon]="'mobile-phones'"></mat-icon>
          <mat-icon *ngIf="!isMobileDevice" [svgIcon]="'wi-fi-connected-devices'"></mat-icon>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex flex-column" [class.w-75]="!isMobileSize" [class.flex-grow-1]="isMobileSize">
            <div>
              <table [class.w-75]="!isMobileSize" [class.w-80]="isMobileSize">
                <tbody>
                  <tr>
                    <td *ngIf="isMobileSize">
                      <div class="p-2">
                        <mat-icon *ngIf="isMobileDevice" [svgIcon]="'mobile-phones'"></mat-icon>
                        <mat-icon *ngIf="!isMobileDevice" [svgIcon]="'wi-fi-connected-devices'"></mat-icon>
                      </div>
                    </td>
                    <td class="u-heading-5 pt-2 pb-2">
                      <adp-label *ngIf="isMobileDevice" labelKey="Dashboard_Mobile_Phones_Label"></adp-label>
                      <adp-label *ngIf="!isMobileDevice" labelKey="Dashboard_Devices_TotalCount_Label"></adp-label>
                    </td>
                    <td class="u-heading-5 pt-2 pb-2" [class.pl-4]="isMobileSize">{{ totalDevices }}</td>
                  </tr>
                  <ng-container *ngIf="isMobileDevice">
                    <tr>
                      <td class="u-body-2" colspan="2" *ngIf="isMobileSize">
                        <adp-label labelKey="Dashboard_Mobile_Phones_Registered"></adp-label>
                      </td>
                      <td class="u-body-2" *ngIf="!isMobileSize"><adp-label labelKey="Dashboard_Mobile_Phones_Registered"></adp-label></td>
                      <td class="u-body-2" [class.pl-4]="isMobileSize">{{ registeredDevices }}</td>
                    </tr>
                    <tr>
                      <td class="u-body-2 text-red" colspan="2" *ngIf="isMobileSize">
                        <adp-label labelKey="Dashboard_Mobile_Phone_Not_Registered"></adp-label>
                      </td>
                      <td class="u-body-2 text-red" *ngIf="!isMobileSize">
                        <adp-label labelKey="Dashboard_Mobile_Phone_Not_Registered"></adp-label>
                      </td>
                      <td class="u-body-2 text-red" [class.pl-4]="isMobileSize">{{ notRegisteredDevices }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <ng-container *ngIf="!isMobileDevice">
              <p class="u-body-2">
                <adp-label labelKey="Dashboard_Devices_SubHeading2"></adp-label>
              </p>
            </ng-container>
          </div>
          <div class="d-flex justify-content-end" [class.w-25]="!isMobileSize" [class.flex-grow-0]="isMobileSize">
            <div class="d-flex">
              <mat-divider [vertical]="true"></mat-divider>
              <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
                <a
                  routerLink="{{ deviceRoute }}"
                  [disabled]="isDisabledController"
                  sf-aria-label="Global_GetStarted_Aria_Label"
                  gtmClick="Manage Devices"
                  gtmLinkURL="CTA">
                  <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isMobilePlan">
      <div class="d-flex pt-2 pb-2 pl-2 pr-0">
        <div class="d-flex">
          <div class="d-flex flex-column align-items-center">
            <div style="display: flex; flex-grow: 1">
              <div style="display: flex">
                <div class="w-100" style="display: flex">
                  <table class="w-100">
                    <tbody>
                      <tr>
                        <td class="u-heading-5 pt-2 pb-2">
                          <adp-label labelKey="Dashboard_Devices_TotalCount_Label"></adp-label>&nbsp;[{{ totalDevices }}]
                        </td>
                        <!--<td class="u-heading-5 pt-2 pb-2">[{{totalDevices}}]</td>-->
                      </tr>
                      <tr>
                        <adp-label labelKey="Dashboard_Devices_Component_Label"></adp-label>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--<p class="u-body-2 text-center padding-left-right-device" style="text-align:left !important;"><adp-label labelKey="Dashboard_Devices_Component_Label"></adp-label></p>-->
              </div>
              <div>
                <adp-image imageKey="Global_Dashboard_Devices_Image"></adp-image>
                <!--<img class="device-img mb-3" [src]="smartDeviceImage?.ImageURL"
                [alt]="smartDeviceImage?.Caption" />-->
              </div>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
            <a
              routerLink="{{ deviceRoute }}"
              [disabled]="isDisabledController"
              sf-aria-label="Global_GetStarted_Aria_Label"
              gtmClick="Manage Devices"
              gtmLinkURL="CTA">
              <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
